export default __webpack_public_path__ + "static/media/team-photo6.91eedc07.jpg";